import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SUBSCRIPTION_URLS } from '../constants/subscription-routes.constant';
import { SubscriptionService } from '../services/subscription.service';

export const entryGuard: CanActivateFn = async () => {
  const subscriptionSvc = inject(SubscriptionService);
  const router = inject(Router);

  try {
    await subscriptionSvc.prepareEntry();

    return true;
  } catch (error) {
    console.error('Error preparing subscription entry', error);

    return router.parseUrl(SUBSCRIPTION_URLS.serviceError);
  }
};
